import React from 'react';
import { prop } from 'ramda';
import { ChangeForm } from '@theme/js/components/common/ChangeForm';
import { withComponent } from '@core/js/components/hocs/withComponent';
import { useComponentConfig } from '@core/js/hooks/component/useComponentConfig';
import { useComponentTranslations } from '@core/js/hooks/component/useComponentTranslations';
import { useComponentProps } from '@core/js/hooks/component';
import { useI18nSelector } from '@core/js/store/hooks';

import * as hooks from '@core/js/components/main/DynamicChangePassword/hooks';
import * as Types from '@theme/js/components/main/DynamicChangePassword/types';
import { DEFAULT_FORM_NAME } from '@core/js/components/main/DynamicChangePassword/constants';

import style from './DynamicChangePassword.scss';

export const DynamicChangePasswordBare: React.FC<Types.IChangePasswordProps> = ({
    error,
    form,
    onClose,
    onSuccess,
    isPasFlow,
    showOldPassword,
    isPopupView /* Lugano changes */
}) => {
    const { formName } = useComponentConfig<Types.IChangePasswordConfig>();
    const changePassword = hooks.useChangePassword({ onSuccess, onClose });
    const changePasswordByPas = hooks.useChangePasswordByPas({ onSuccess, onClose, showOldPassword });

    /* Lugano changes */
    const { tkPrefix } = useComponentProps<Types.IChangePasswordComponentProps>();
    const translate = useComponentTranslations();
    const descriptionHTML = { __html: translate('description') };
    const showTranslationKeys = useI18nSelector(prop('showTranslationKeys'));
    /* Lugano changes */

    return (
        /* Lugano changes */
        <div className={`${style.container} ${isPopupView && style.popupView || ''}`}>
            {!isPopupView &&
                (showTranslationKeys || translate('formHeader') !== `${tkPrefix}formHeader`)
                    ? <h2 className={style.title}>{translate('formHeader')}</h2>
                    : null
            }
            {!isPopupView &&
                (showTranslationKeys || translate('description') !== `${tkPrefix}description`)
                    ? <p className={style.description} dangerouslySetInnerHTML={descriptionHTML}></p>
                    : null
            }
            <ChangeForm
                formError={error}
                formName={form || formName || DEFAULT_FORM_NAME}
                classNames={style} /* Lugano changes */
                onSubmit={isPasFlow ? changePasswordByPas : changePassword}
            />
        </div>
        /* Lugano changes */
    );
};

export const DynamicChangePassword = withComponent({
    tkPrefix: 'playtech.mobile.system.dynamic-change-password.'
})(DynamicChangePasswordBare);

export default DynamicChangePassword;
